import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const LoadUsersCashRegister = () => {
  const { isProfileAdmin } = useLocalStorage()
  const [data, setData] = useState<any>(null)
  const { getUnitId } = useLocalStorage()

  const { httpClientPost } = useRemoteClientPost()
  const { showToast } = useToast()

  useEffect(() => {
    if (isProfileAdmin()) {
      httpClientPost('/usuarios/filtro?page=0&size=1000', {
        perfis: [1, 3],
        idUnidade: [getUnitId()]
      })
        .then((response: any) => {
          setData(response.data.data.content)
        })
        .catch(() => showToast('Erro ao carregar usuários de caixa', 'error'))
    }
  }, [])

  return {
    data
  }
}
